<script lang="ts" setup>
import Header from '~/components/layouts/Header.vue'
import Footer from '~/components/layouts/Footer.vue'
import BottomBar from '~/components/custom-ui/BottomBar.vue'
</script>

<template>
    <div class="min-h-screen flex flex-col justify-between">
         <div class="main_row">
            <Header />
            <NuxtPage />
        </div>
        <Footer />
        <BottomBar />
    </div>
</template>